import { render, staticRenderFns } from "./checklist-section.vue?vue&type=template&id=0512a062&scoped=true&"
import script from "./checklist-section.vue?vue&type=script&lang=js&"
export * from "./checklist-section.vue?vue&type=script&lang=js&"
import style0 from "./checklist-section.vue?vue&type=style&index=0&id=0512a062&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0512a062",
  null
  
)

export default component.exports